<template>
	<img class="cursor" :src="captcha.blobUrl" @click.stop.prevent="refresh"/>
</template>

<script>
	import Captcha from "../model/common/Captcha";
	export default {
		data () {
			return {}
		},
		components: {},
		watch: {
			"captcha.refreshTime"(){
				this.refresh();
			}
		},
		props: {
			captcha: {
				type: Captcha,
				required: true
			}
		},
		methods: {
			refresh(){
				let that = this;
				this.captcha.httpCaptcha();
			}
		},
		mounted(){
			this.refresh();
		}
	}
</script>


<style lang="less" rel="stylesheet/less">


</style>





// WEBPACK FOOTER //
// NbCaptcha.vue?1f83c876